import LocomotiveScroll from 'locomotive-scroll';

let previousTop = 0;
const scrollDelta = 5;
const scrollOffset = 50;
const $selector = $('.js-navpanel');
const $body = $('body');

function showNavpanel (obj) {
	let currentTop = obj.scroll.y;
	if (previousTop - currentTop > scrollDelta) {
		$body.addClass('show-header');
	} else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
		$body.addClass('show-w');
		$body.removeClass('show-header');
	}
	if (currentTop < scrollOffset) {
		$body.removeClass('show-header show-w');
	}
	previousTop = currentTop;
}

function showScrollTopButton (obj) {
	if (obj.scroll.y > 100) {
		$('.js-top').addClass('is-visible');
	} else {
		$('.js-top').removeClass('is-visible');
	}
}

function lazyLoad (obj) {
	for (let key in obj.currentElements) {
		const el = obj.currentElements[key].target || obj.currentElements[key].targetEl;
		const progress = obj.currentElements[key].progress;
		const lazy = el.getAttribute('data-scroll-lazy');

		if (lazy) {
			if (!el.classList.contains('is-load')) {
				const src = el.getAttribute('data-src');
				if (lazy === 'image' || lazy === 'video') {
					el.setAttribute('src', src);
				} else if (lazy === 'bg') {
					el.style.backgroundImage = `url(${src})`;
				} else if (lazy === 'sticky') {
					const sticky = el.querySelector('[data-scroll-sticky]');
					if (sticky) {
						sticky.style.backgroundImage = `url(${src})`;
					}
				}
				el.classList.add('is-load');
			}

			if (lazy === 'video' && el.getAttribute('data-scroll-autoplay')) {
				if (progress < 0.2 || progress > 0.8) {
					el.pause();
				} else {
					el.play();
				}
			}
		}
	}
}

export default function () {
	const container = document.querySelector('[data-scroll-container]');
	if (container) {
		const locoScroll = new LocomotiveScroll({
			el: container,
			smooth: true
		});

		locoScroll.on('scroll', function (obj) {
			showNavpanel(obj);
			showScrollTopButton(obj);
			lazyLoad(obj);
		});

		locoScroll.scrollTo(1);

		$('.js-top').removeClass('is-visible').on('click', function () {
			locoScroll.scrollTo('top');
		});
	}
}



// WEBPACK FOOTER //
// ./src/js/_modules/locomotive-scroll.js